import { Component, OnInit } from '@angular/core';
import { ToastService } from '../../../services/toast.service';
import { Parametro } from '../../../types/Parametro.type';
import { ParametrizacaoService } from './parametrizacao.service';

@Component({
  selector: 'app-parametrizacao',
  templateUrl: './parametrizacao.component.html',
  styleUrl: './parametrizacao.component.css',
})
export class ParametrizacaoComponent implements OnInit {
  parametros!: Parametro[];
  clonedParametro: { [s: string]: Parametro } = {};
  loading: boolean = true;

  constructor(private parametrizaoService: ParametrizacaoService, private toastService: ToastService) {}

  ngOnInit() {
    this.parametrizaoService.getList().subscribe((data) => {
      this.parametros = data;
      this.loading = false;
    });
  }

  editar(parametro: Parametro) {
    this.clonedParametro[
      (parametro.id) as string
    ] = { ...parametro };
  }

  desativar(parametro: Parametro) {}

  ativar(parametro: Parametro) {}

  salvar(parametro: Parametro) {

    this.parametrizaoService.put(parametro).subscribe({
      next: () => {
        this.toastService.sucesso("Sucesso", "Atualização realizada")
      },
      error: () => {
        this.toastService.erro("Erro", "Erro ao atualizar")
      }
    })
  }

  cancelar(parametro: Parametro, index: number) {
    this.parametros[index] =
      this.clonedParametro[
        (parametro.id) as string
      ];
    delete this.clonedParametro[
      (parametro.id) as string
    ];
  }
}
